<template>
  <master-layout no-bottom-pad>
    <div class="min-h-full bg-[#F9F9F9] lg:w-[calc(100vw-292px)]">
      <div
        class="max-w-[680px] mx-auto flex flex-col gap-6 px-6 pt-[24px] pb-4 lg:pt-[56px]"
        :class="{ '!pt-[68px]': isIos, '!pt-[max(24px,env(safe-area-inset-top))]': isAndroid }"
      >
        <BackButton variant="bare" @click="back" />
        <h1 class="page-title">Photodrop</h1>

        <div
          class="bg-white border border-[#E0E0E0] rounded-2xl p-6 flex flex-col items-center gap-6"
        >
          <img
            src="/assets/images/photodrop-logo.svg"
            alt="Photodrop"
            class="w-[75px] drop-shadow-[0px_0.936px_4.68px_rgba(0,0,0,0.1)]"
          />
          <p class="text-[16px] leading-[24px] text-center text-black font-aktiv-grotesk-regular">
            The Generations Pastors Conference 2026 photo platform is live — tap below to view
            photos as they're added.
          </p>
        </div>

        <div class="flex flex-col gap-3">
          <button
            v-if="hasMementoAccess"
            class="h-12 px-5 rounded-[100px] text-[20px] leading-[24px] font-aktiv-grotesk-medium flex items-center justify-center gap-2 bg-gens-cyan text-white"
            data-event-tracking="gensapp-photodrop-view2026photos"
            @click="viewCurrentPhotos"
          >
            View 2026 photos
            <svg
              class="w-6 h-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M14 4h6v6M20 4l-9 9M18 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          <button
            v-if="hasOldPhotodrop"
            class="h-12 rounded-[100px] text-gens-cyan text-[20px] leading-[24px] font-aktiv-grotesk-medium flex items-center justify-center"
            data-event-tracking="gensapp-photodrop-browsepastyears"
            @click="browsePastYears"
          >
            Browse past years
          </button>
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { mapState } from 'vuex';
import platformMixin from '@/mixins/platformMixin';
import { buildPhotodropMementoUrl, hasMementoAccess as hasGpc2026 } from '@/utils/memento';
import BackButton from '@/components/common/BackButton.vue';

export default {
  name: 'PhotodropWelcome',
  components: { BackButton },
  mixins: [platformMixin],
  computed: {
    // name is the raw profile state (DB name column), NOT the profile `name`
    // getter — memento must receive the full name, never the preferred name.
    ...mapState('profile', [
      'hasOldPhotodrop',
      'email',
      'country',
      'groupName',
      'name',
      'conferences',
    ]),

    // Gates "View 2026 photos": true whenever the delegate attended GPC 2026.
    // "Browse past years" stays gated on hasOldPhotodrop below — that's
    // specifically about having OLD conference history to browse, which is a
    // separate question from 2026 attendance.
    hasMementoAccess() {
      return hasGpc2026(this.conferences);
    },
  },
  async ionViewWillEnter() {
    // No redirect guard here on purpose. The page keeps itself honest by gating
    // each button on its own fact — "View 2026 photos" on hasMementoAccess,
    // "Browse past years" on hasOldPhotodrop — so it's always safe to land on.
    //
    // The previous guard redirected isAbsentAlumni delegates to /photodrop. The
    // nav shows PhotoDrop *only* to absent alumni, so it bounced every delegate
    // the nav sent here, memento access and all, back to the old gallery.
    //
    // Refresh the flag: hasOldPhotodrop gates the "Browse past years" button.
    await this.$store.dispatch('profile/fetchHasOldPhotodrop');
  },
  methods: {
    back() {
      this.$router.push('/home');
    },
    viewCurrentPhotos() {
      window.open(
        buildPhotodropMementoUrl({
          name: this.name,
          email: this.email,
          country: this.country,
          groupName: this.groupName,
        }),
        '_blank',
      );
    },
    browsePastYears() {
      this.$router.push('/photodrop');
    },
  },
};
</script>
